import { IPodData } from 'services/pod/types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getFreshServicePodDataByContactId } from 'services/pod';
import { convertSimplifiedToPodData } from 'store/pod/helpers';

interface IProps {
  psaId: number;
  contactId: number;
}

export const getFreshServiceDataByContactId = createAsyncThunk<IPodData, IProps>(
  'pod/getFreshServiceDataByContactId',
  async ({ psaId, contactId }) =>
    getFreshServicePodDataByContactId(psaId, contactId)
      .then(r => r.data)
      .then(data => convertSimplifiedToPodData(data)),
);
